import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../AddressFinder/AddressFinderTypes";
import "./OccurrenceFormDialog/OccurrenceFormDialog";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import OccurrenceForm from './OccurrenceForm/OccurrenceForm';
import { StringHelpers, UrlHelpers } from "../../more/Helpers";
import { FinderTypes } from "../FinderBase/FinderBaseTypes";
class OccurrenceHome extends compose(FinderBaseV2) {

    //templateString = template;

    tableContainer: HTMLElement; // will be passed as a function parameter

    private occurrenceTable_formatterFunction(cell: StaticTable.StaticTableCell<any>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {

            case "details":
            case "actions":
                // hier button einbauen
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    "class": "mds-button-base round tertiaryBG mds-hover-bright",
                    "onclick": lang.hitch(this, this.openOccurrenceForm, cell.entity)
                }, node);


                //this.UiModder.domConstruct.create("SPAN", { "innerHTML": this.translations["OccurrenceForm__tableHeader_details"], "class": "large_screen" }, btn)
                this.UiModder.domConstruct.create("I", { "class": "fas fa-search-plus" }, btn, "first");
                return true;
                break;

            default:
                return false;
        }
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // Events handlers--------------------------------------------------START

    private _onDetailsButton_click(cell: StaticTable.StaticTableCell<Occurrence.OccurenceEntity>, evt: MouseEvent): void {

        this.openOccurrenceForm(cell.entity);
    }

    openOccurrenceForm(entity?: Occurrence.OccurenceEntity | string): void {

        let label = "General_New";
        
        let occurrenceForm = new OccurrenceForm();
        if (typeof (entity) == "string") {
            occurrenceForm.entityID = entity;
            label = "General_Loading";
            occurrenceForm.entityID = entity;
        }
        else if (!!entity) {
            label = entity.$Displayname;
            occurrenceForm.entityID = entity.ID;
        }
        occurrenceForm.show("dlg", label, this.getTabContainerName());

        on(occurrenceForm, "saved", lang.hitch(this, this.reload));
        on(occurrenceForm, "requestOccurrenceForm", lang.hitch(this, this._onRequestOccurrenceForm));
        
        occurrenceForm.startup();
    }

    private _onRequestOccurrenceForm(targetID: string) {
        if (targetID) {
            this.openOccurrenceForm(targetID);
        }
    }
   
    private createNew(): void {
        this.openOccurrenceForm();
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<Occurrence.OccurenceEntity>, group: any, evt: MouseEvent) {
        //console.debug("_onClick_Row", rowLine, rowGroup.entity, evt);
        this.openOccurrenceForm(row.rowGroup.entity);
    }

    

    private _onEntitySaved() {
        this.getFilterlist(1);
    }

    _onEmbedding() {
        super._onEmbedding.apply(this, arguments as any);
    }

    // --------------------own methods ----------------------------end
    protected _customFinderSetupConfig: Partial<FinderTypes.FinderSetupConfig> = null;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.setEntitylistPropertyName("entities");

        let config: FinderTypes.FinderSetupConfig = {
            configUrl: null,//"Eforms/GetFilterpanelOptions",
            configCallfunction: "Webtool_Occurrence_API__GetFilterOptionsJSON",
            filterdataUrl: null,//"Eforms/LoadOccurrenceListJSON",
            filterdataCallfunction: "Webtool_Occurrence_API__LoadOccurrenceListJSON",
            rowClickFunction: lang.hitch(this, this._onClick_Row),
            tableFormatterFunction: lang.hitch(this, this.occurrenceTable_formatterFunction),
            newEntryParams: {
                neededUserRole: null,
                callback: lang.hitch(this, this.createNew)
            },
        };

        if (this._customFinderSetupConfig) {
            for (let key in this._customFinderSetupConfig) {
                config[key] = this._customFinderSetupConfig[key];
            }
        }

        this.finderSetup(config);

        //this.table.addDefaultRowActionButton("view", lang.hitch(this, this._onDetailsButton_click));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        
        let createVal = UrlHelpers.getUrlParameterValue("create");
        let viewVal = UrlHelpers.getUrlParameterValue("view");
        if (createVal) {
            UrlHelpers.setUrlParameter("ctype", createVal);
            UrlHelpers.removeUrlParameter("create");
            this.createNew(); // Problem: wenn es noch eine Instanz von OccHome gibt, führt diese das jetzt auch aus
        } else if (viewVal) {
            UrlHelpers.removeUrlParameter("view");

            this.openOccurrenceForm(viewVal);
        }

        //this.setTitles(null, this.translations["OccurrenceForm__modulHeader"]);

    }
}

export default mdsWidget(OccurrenceHome);